module.exports = __webpack_public_path__ + "8f51bcf8aa93aa5804ccc3f26203ca8e.otf";